// Shared money / duration formatting for the billing PlanCard + PricingTimeline
// (both render the same Stripe-schedule timeline, so they shared these helpers
// verbatim — co-located here to avoid the two copies drifting).

const CURRENCY_SYMBOLS = { gbp: '£', usd: '$', eur: '€' };
const AVG_MONTH_MS = 30.4375 * 24 * 60 * 60 * 1000;

/** Whole monthly billing cycles between two ISO dates (min 1); null if either is missing. */
export const monthsBetween = (startDate, endDate) => {
	if (!startDate || !endDate) return null;
	return Math.max(1, Math.round((new Date(endDate).getTime() - new Date(startDate).getTime()) / AVG_MONTH_MS));
};

/** Fixed-decimal money, e.g. `£29.00`. Empty string when there's no amount. */
export const money = (amount, currency, decimals = 2) => {
	if (amount == null) return '';
	const symbol = CURRENCY_SYMBOLS[currency?.toLowerCase()] ?? '';
	return `${symbol}${amount.toFixed(decimals)}`;
};

/** Compact money — `£29` when whole, `£29.50` otherwise. Null when there's no amount. */
export const formatPlanAmount = (amount, currency) => {
	if (amount == null) return null;
	const symbol = CURRENCY_SYMBOLS[currency?.toLowerCase()] ?? '';
	const formatted = Number.isInteger(amount) ? amount.toString() : amount.toFixed(2);
	return `${symbol}${formatted}`;
};
